module.exports = require("sequelize-typescript");